import _ from 'lodash'

export const paginationMixin = {
  data () {
    return {
      items: [],
      totalItems: 0,
      loading: false,
      pagination: {
        page: 1,
        descending: false
      },
      loadingFilters: true,
      allFilters: []
    }
  },
  props: {
    disableStore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    search: {
      set (value) {
        if (this.disableStore) return
        this.$store.commit('pagination/setSearch', value)
      },
      get () {
        return this.$store.state.pagination.search
      }
    },
    filters: {
      set (value) {
        if (this.disableStore && typeof (this.filters) !== 'string') return
        this.$store.commit('pagination/setFilters', value)
      },
      get () {
        return (this.filter) ? this.$store.state.pagination.filters : {}
      }
    },
    lastRoute: {
      set (value) {
        if (this.disableStore) return
        this.$store.commit('pagination/setLastRoute', value)
      },
      get () {
        return this.$store.state.pagination.lastRoute
      }
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },

  methods: {
    setItems (responseData) {
      this.items = responseData.results
    },
    debouncedFetchData: _.debounce(function () { this.fetchData() }, 1000),
    fetchData () {
      this.loading = true
      this.axios
        .get(this.path + this.getPath())
        .then(response => {
          this.setItems(response.data)
          this.setPageFromStore()
          this.totalItems = response.data.count
          this.loading = false
        })
        .catch(error => {
          let validError = error && error.response && error.response.data && error.response.data.detail
          if (validError && error.response.data.detail.includes('Página inválida')) {
            this.setPageAndStore(1)
          } else {
            this.$store.commit('setErrorMsg', error)
          }
        })
    },
    getPaginationPath () {
      let pageSize = `?page_size=${this.pagination.rowsPerPage}`
      let page = `&page=${this.pagination.page}`
      this.setStoreFromPage(this.pagination.page)
      let ordering = ''
      if (this.pagination.sortBy) {
        ordering = `&ordering=${this.pagination.descending ? '' : '-'}${this.pagination.sortBy}`
      }
      return pageSize + page + ordering
    },
    getFilteringPath () {
      let filterPath = ''
      for (let column of Object.keys(this.filters)) {
        // We check if current filter is a set of elements or a date.
        if (Array.isArray(this.filters[column])) {
          filterPath += (this.filters[column].length) ? `&${column}[]=${this.filters[column].join(`&${column}[]=`)}` : ''
        } else {
          if (this.filters[column]) {
            filterPath += `&${column}=${this.filters[column]}`
          }
        }
      }
      if (this.filter) {
        this.$store.commit('pagination/setFilters', this.filters)
      }
      return filterPath
    },
    getSearchingPath () {
      return `&q=${this.search}`
    },
    getPath () {
      return this.getPaginationPath() + this.getFilteringPath() + this.getSearchingPath()
    },
    changeSort (header) {
      if (header.hasOwnProperty('sortable') && !header.sortable) {
        return
      }
      if (this.pagination.sortBy === header.value) {
        this.$set(this.pagination, 'descending', !this.pagination.descending)
      } else {
        this.$set(this.pagination, 'sortBy', header.value)
        this.$set(this.pagination, 'descending', false)
      }
    },

    columnValueList (headerValue) {
      let columnItems = this.allFilters.filter(x => x.value === headerValue)
      return (columnItems.length) ? columnItems[0].items : []
    },
    submitFiltering () {
      this.fetchData()
    },
    fetchFilters () {
      this.loadingFilters = true
      this.axios
        .get(this.filterPath)
        .then(response => {
          this.allFilters = response.data.filters
          this.loadingFilters = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    hasSettedFilters () {
      return Object.keys(this.filters).some(header => this.headers.map(header => header.value).includes(header))
    },
    isAnotherRoute () {
      return !this.lastRoute || this.lastRoute !== this.$router.currentRoute.name
    },
    setPageAndStore (page) {
      this.pagination.page = page
      this.setStoreFromPage(page)
    },
    setStoreFromPage (page) {
      let storePage = this.$store.state.pagination.page
      storePage[this.$router.currentRoute.name] = page
      this.$store.commit('pagination/setPage', storePage)
    },
    setPageFromStore () {
      let currentRoute = this.$router.currentRoute.name
      this.pagination.page = (this.$store.state.pagination.page.hasOwnProperty(currentRoute))
        ? this.$store.state.pagination.page[currentRoute]
        : 1
    }
  },

  created () {
    if (this.filter) {
      if (this.isAnotherRoute()) {
        if (!this.disableStore) {
          this.$store.commit('pagination/setPage', {})
        }
        this.filters = {}
        this.search = ''
      }
      if (!this.hasSettedFilters()) {
        this.filters = {}
        for (let header of this.headers.filter(x => x.filterField)) {
          this.filters[header.value] = []
        }
      }
      this.fetchFilters()
      this.lastRoute = this.$router.currentRoute.name
    }
    this.setPageFromStore()
  },

  watch: {
    pagination: {
      handler () {
        if (!this.loading) {
          this.fetchData()
        }
      },
      deep: true
    },
    'search' () {
      this.setPageAndStore(1)
      this.debouncedFetchData()
    }
  }
}
